type AppStatusProps = {
    status?: string;
};

/**
 * The AppStatus component.
 *
 * This component simply renders an HTTP status indicating whether there's an app error or not. Used by our health checks
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the AppStatus component
 */
export default function AppStatus({ status = "ok" }: AppStatusProps) {
    return (
        <div className="appStatus" data-testid="app-status">
            CBC Feed Application Status: {status}
        </div>
    );
}
